import request from '@/utils/http';

// 司机收款时长配置 分页查询
export const queryPage = data => {
    return request({
        url: `/api-antms/query/driverPaymentDurationConfig/queryPage`,
        method: 'post',
        data
    });
};
// 司机收款时长配置 总数查询
export const queryCount = data => {
    return request({
        url: `/api-antms/query/driverPaymentDurationConfig/queryPageCount`,
        method: 'post',
        data
    });
};

// 司机收款时长配置 编辑记录查询
export const queryEditRecord = data => {
    return request({
        url: `/api-antms/query/driverPaymentDurationConfig/queryEditRecord`,
        method: 'get',
        params: data
    });
};

// 司机收款时长配置 停用/启用
export const updateConfigFlag = data => {
    return request({
        url: `/api-antms/billing/paymentDurationConfig/updateConfigFlag`,
        method: 'post',
        data
    });
};

// 司机收款时长配置 删除
export const handleDelete = data => {
    return request({
        url: `/api-antms/billing/paymentDurationConfig/delete`,
        method: 'get',
        params: data
    });
};

// 司机收款时长配置 明细查询
export const updateDetail = data => {
    return request({
        url: `/api-antms/billing/paymentDuration/updateDetail`,
        method: 'get',
        params: data
    });
};

// 司机收款时长配置审批 明细查询
export const initDetail = data => {
    return request({
        url: `/api-antms/billing/paymentDuration/initDetail`,
        method: 'get',
        params: data
    });
};

// 司机收款时长配置 校验
export const checkInfo = data => {
    return request({
        url: `/api-antms/billing/paymentDuration/checkInfo`,
        method: 'post',
        data
    });
};

// 司机收款时长配置 确认提交
export const confirmSubmission = data => {
    return request({
        url: `/api-antms/billing/paymentDuration/confirmSubmission`,
        method: 'post',
        data
    });
};

// 提交mip审核
export const createProcess = params => {
    return request({
        url: `/api-iflow/approveProcess?tenantCode=annto&appCode=APP202103050019`,
        method: 'post',
        data: params
    }).then(res => res);
};
